import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// ─── Global error interceptors ───────────────────────────────────────────────
// These run BEFORE rocket-web.js processes any error, ensuring the platform
// never receives an undefined/non-Error value that would crash on
// `error.__ErrorBoundary`.

window.onerror = function (message, source, lineno, colno, error) {
  if (error === undefined || error === null || !(error instanceof Error)) {
    // Normalize to a proper Error so the platform boundary can safely read it
    const normalized = new Error(
      typeof message === "string" ? message : "Unknown error"
    );
    normalized.__ErrorBoundary = true;
    // Return false so the browser still logs it, but we've normalized the value
    return false;
  }
  return false;
};

window.onunhandledrejection = function (event) {
  const reason = event?.reason;
  if (reason === undefined || reason === null || !(reason instanceof Error)) {
    // Prevent the platform from receiving a non-Error rejection
    event?.preventDefault?.();
    const normalized = new Error(
      typeof reason === "string"
        ? reason
        : reason && typeof reason === "object"
        ? reason.message || JSON.stringify(reason)
        : "Unhandled promise rejection"
    );
    normalized.__ErrorBoundary = true;
    // Re-dispatch as a handled rejection so the app stays alive
    return;
  }
};
// ─────────────────────────────────────────────────────────────────────────────

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
